import { useTranslation } from "react-i18next";
import Button from "components/shared/Button";
import GenericFallback from "../GenericFallback";

export type TUserContextFallbackProps = {
  onLogout: () => void;
  logoutTimeout?: number;
};

const UserContextFallback = ({ onLogout }: TUserContextFallbackProps) => {
  const { t } = useTranslation("common", {
    keyPrefix: "messages",
  });

  return (
    <GenericFallback message={t("userDoesntHaveAccess")}>
      <Button onClick={onLogout} variant="contained">
        {t("reLoginSuggestion")}
      </Button>
    </GenericFallback>
  );
};

export default UserContextFallback;
